// extracted by mini-css-extract-plugin
module.exports = {"accountsList":"WSAccountsListV2_accountsList__3-lAL","account":"WSAccountsListV2_account__lzHUw","hasSingleAccount":"WSAccountsListV2_hasSingleAccount__12ld1"};